<form [formGroup]="form">
    <formly-form [options]="options" [model]="dli()" [fields]="fields()" [form]="form">
    </formly-form>
</form>
